import gql from "graphql-tag";

// Chapter card data for the subjects page. GroupCards runs it once for the whole subject
// (no chapter argument) and passes the result to every InnerGroupCards; firing one request
// per card made ~20-30 simultaneous calls, which api.rizee.in's firewall rejects with 403.
export const FETCH_CHAPTER_CARDS = gql`
query($student_user_exam_id: Int!,
  $exam_id: Int,
  $class_id: Int,$subject: Int, $chapter:Int) {
  getSubjects(student_user_exam_id: $student_user_exam_id,
  exam_id: $exam_id,
  class_id: $class_id, subject: $subject, chapter: $chapter){
      studentChapters{
        id
        enabled
        errorExamsEnabled
        revMatrialEnabled
        total_questions
        attempted_questions
        practice_wrong_answered
        error_questions
        chapterWisePreviousQuestionsCount
        chapterGraph{
        value
        timestamp
        correct
        wrong 
       }  
      }
  }
}
`;
